import { Grid, Modal } from "antd-mobile";
import { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import styled from "styled-components";
import { IMAGE_PREFIX_URL } from "../../../../utils/constants";
import { big2num } from "../../../../utils/utils";
import FeatureProcesses from "../../../../components/FeatureProcesses";
import Attributes from "../../../../components/Attributes";
import Img from "../../../../components/Image";
const formatter = (num, per, f) => {
  return num === undefined
    ? "-"
    : per
    ? parseInt(num / 100)
    : f
    ? num.toFixed(f)
    : num;
};
export default function useEquipModal() {
  const intl = useIntl();
  const show = ({ onConfrim = () => {}, equip = {} }) => {
    const isEmpty = equip.stock <= equip.sales;
    return Modal.show({
      // title: intl.formatMessage({
      //   id: "pages.shop.equip_modal.title",
      //   defaultMessage: "購買",
      // }),
      bodyClassName: "runbit_modal ",
      showCloseButton: true,
      actions: [
        {
          key: "1",
          className: "border_btn",
          text: intl.formatMessage({
            id: "common.cancel",
            defaultMessage: "取消",
          }),
        },
        {
          key: "2",
          className: "primary_btn  " + (isEmpty ? "disabled" : ""),
          text: intl.formatMessage({
            id: "common.bug",
            defaultMessage: "購買",
          }),
          primary: true,
        },
      ],
      onAction: (action, index) => {
        if (isEmpty && action.key === "2") return;
        onConfrim(action);
      },
      closeOnAction: false,
      content: <EquipModal equip={equip} intl={intl} />,
    });
  };
  return {
    show,
  };
}

function EquipModal({ equip, intl }) {
  const [process, setProcess] = useState(0);
  useEffect(() => {
    const timer = setTimeout(() => {
      setProcess((equip.sales / equip.stock) * 100);
    }, 500);
    return () => {
      timer && clearTimeout(timer);
    };
  }, []);
  return (
    <div className="text-center" style={{ paddingTop: "2.0rem" }}>
      <EquipName>
        <span>
          {new Array(equip.level || 0).fill("").map((e, i) => (
            <img key={i} src="/image/foot.png" width={8} alt="foot" />
          ))}{" "}
          {equip.collection_name || "Level"}
        </span>
      </EquipName>
      <div
        style={{
          display: "inline-block",
          height: "12.0rem",
          overflow: "hidden",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Img
        width={'100%'}
          src={IMAGE_PREFIX_URL + "/images/" + equip.cover}
          fit="contain"
          alt={"cardImage"}
        />
      </div>

      {/* <T>{intl.formatMessage({ id: "发行量"})}
      {equip.stock}</T> */}
      {/* <Processes2>
        <div className="inner" style={{ width: process + "%" }}></div>
      </Processes2> */}
      <div style={{ margin: "0 -1.5rem" }}>
        <Attributes equip={equip} simple={true} intlfn={intl} />
      </div>
      <Detail>
        <FeatureProcesses
          intlfn={intl}
          specialty={equip.specialty || 0}
          aesthetic={equip.aesthetic || 0}
          comfort={equip.comfort || 0}
          resilence={equip.resilence || 0}
        />
      </Detail>
      <Flex justify="between" className="mb-15">
        <Label>{intl.formatMessage({ id: "发行量" })}</Label>
        <Value>{equip.stock}</Value>
      </Flex>
      <Flex justify="between" className="mb-15">
        <Label>{intl.formatMessage({ id: "收益率" })}</Label>
        <Value>
          {formatter(equip.income_rate, 0, 2)}RT/
          {intl.formatMessage({ id: "天" })}
        </Value>
      </Flex>
      <Flex justify="between" className="mb-15">
        <Label>
          {intl.formatMessage({
            id: "pages.shop.equip_modal.RB",
            defaultMessage: "购买價格(RT)",
          })}
        </Label>
        <Value>{big2num(equip.price1)}</Value>
      </Flex>
      <Flex justify="between">
        <Label>
          {intl.formatMessage({
            id: "pages.shop.equip_modal.RBCT",
            defaultMessage: "兌換價格(RBCT)",
          })}
        </Label>
        <Value>{equip.price0}</Value>
      </Flex>
    </div>
  );
}

const Flex = styled.div`
  display: flex;
  justify-content: ${(props) =>
    props.justify === "between" ? "space-between" : ""};
`;
const Label = styled.div`
  font-style: normal;
  font-weight: 400;
  font-size: 1.4rem;
  line-height: 1.4rem;
  color: #969696;
`;

const Value = styled.div`
  font-style: normal;
  font-weight: 600;
  font-size: 1.4rem;
  line-height: 1.4rem;

  color: #0b0b0b;
`;

// const Image = styled.img`

//   margin: auto;
//   width: 17.0rem;
//     /* height: 17.0rem; */

//     margin-top: 0.5rem;
//     margin-bottom: 1rem;
// `;

const Detail = styled.div`
  margin: 1rem -0.5rem;
  margin-bottom: 1rem;
  background: #f4f5f6;
  box-shadow: 0rem 0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 1.6rem;
  padding: 0.8rem 1px 1rem;
  /* background: #f4f5f6;
  box-shadow: .0rem .0rem 2px rgba(0, 0, 0, 0.08);
  border-radius: 1.6rem; */
  /* padding: 1.0rem 4.0rem; */
  /* text-align: left; */
  /* font-style: normal;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.4rem;
  margin: 2.0rem auto;
  color: #969696; */

  /* strong {
    font-weight: 600;
    font-size: 1.4rem;
    color: #000000;
  } */
`;

const Processes2 = styled.div`
  background: #cccccc;
  border: 1px solid #344362;
  border-radius: 1.5rem;
  height: 1.8rem;
  overflow: hidden;
  .inner {
    height: 100%;
    width: 0%;
    background: url(image/icons/icon22.png) repeat-x;
    background-size: 3rem 100%;
    background-position: right top;
    background-color: #5acdc3;
    border-radius: 1.5rem;
    transition: width 1.5s;
  }
`;

const T = styled.div`
  font-weight: 400;
  font-size: 1.3rem;
  line-height: 1.4rem;
  text-align: left;
  margin-bottom: 1rem;
  margin-top: 2rem;
  color: #000000;
`;

const EquipName = styled.div`
  background: #f4f5f6;
  border-radius: 0rem 0rem 1.3rem 1.3rem;
  text-align: center;
  width: 14.6rem;
  margin: auto;
  padding: 0.5rem 0 0.8rem;
  font-style: normal;
  font-weight: 500;
  font-size: 1.5rem;
  line-height: 1.5rem;
  position: absolute;
  color: #000000;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
`;
